import { useMutation } from '@apollo/client';
import { ScheduleCancellationData } from 'types/api';
import { errorHandler } from 'utils/ErrorHandler';
import { CANCEL_SCHEDULE } from '..';

function useMutationCancelSchedule() {
  const [cancelSchedule] = useMutation(CANCEL_SCHEDULE);

  const handleCancelSchedule = async (
    scheduleId: string,
    param: ScheduleCancellationData,
    callback?: () => void,
  ) => {
    try {
      const response = await cancelSchedule({
        variables: { scheduleId, param },
      });

      if (response) {
        window.showToast('일정이 취소되었습니다.', 'default');

        if (callback) {
          callback();
        }
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  return { handleCancelSchedule };
}

export default useMutationCancelSchedule;
